module.exports = __webpack_public_path__ + "img/loading.21536b2f.gif";